import { useParams } from 'react-router-dom';
import { useWalletDetailQuery } from 'hooks/use-wallet-detail-query/use-wallet-detail-query.hook';

export function useBenefitDetailInformation() {
  const { benefitId } = useParams();

  const { data, isLoading } = useWalletDetailQuery(benefitId);

  const { content_actions: contentActions } = data || {};

  const disclaimer = contentActions?.find(({ id }) => id === 'disclaimer');

  return { disclaimer: disclaimer?.description || null, isLoading };
}
